module.exports = __webpack_public_path__ + "img/product004.b7563f5b.jpg";